import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "content", "className"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
var rootStyles = process.env.NODE_ENV === "production" ? {
  name: "1e7zpqf",
  styles: "display:flex;flex-flow:row nowrap;padding:15px 0 0"
} : {
  name: "bgtvzf-rootStyles",
  styles: "display:flex;flex-flow:row nowrap;padding:15px 0 0;label:rootStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RhYkdyb3VwLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNbUIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVGFiR3JvdXAudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5cbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB0eXBlIHsgVGFiR3JvdXBQcm9wcyB9IGZyb20gJy4uL3R5cGVzJztcblxuY29uc3Qgcm9vdFN0eWxlcyA9IGNzcyh7XG4gIGRpc3BsYXk6ICdmbGV4JyxcbiAgZmxleEZsb3c6ICdyb3cgbm93cmFwJyxcbiAgcGFkZGluZzogJzE1cHggMCAwJyxcbn0pO1xuXG5jb25zdCBUYWJHcm91cDogUmVhY3QuRkM8VGFiR3JvdXBQcm9wcz4gPSAoe1xuICBjaGlsZHJlbixcbiAgY29udGVudCxcbiAgY2xhc3NOYW1lLFxuICAuLi51bmhhbmRsZWRQcm9wc1xufSkgPT4gKFxuICA8ZGl2XG4gICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gICAgY3NzPXtyb290U3R5bGVzfVxuICAgIHJvbGU9XCJ0YWJsaXN0XCJcbiAgICB7Li4udW5oYW5kbGVkUHJvcHN9PlxuICAgIHtjaGlsZHJlbiAhPSBudWxsID8gY2hpbGRyZW4gOiBjb250ZW50fVxuICA8L2Rpdj5cbik7XG5cblRhYkdyb3VwLmRpc3BsYXlOYW1lID0gJ1RhYkdyb3VwJztcblxuZXhwb3J0IGRlZmF1bHQgVGFiR3JvdXA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var TabGroup = function TabGroup(_ref) {
  var children = _ref.children,
      content = _ref.content,
      className = _ref.className,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("div", _extends({
    className: className,
    css: rootStyles,
    role: "tablist"
  }, unhandledProps), children != null ? children : content);
};

TabGroup.displayName = 'TabGroup';
export default TabGroup;